import React, { ReactNode } from 'react';
import { Center, Flex, HStack, Image, Text } from '@chakra-ui/react';

import { TimedProgress } from '../../TimedProgress/TimedProgress';

export type ScanStateLayoutProps = {
  heading: string;
  onAnimationComplete: () => void;
  imageSrc?: string;
  headingIcon?: ReactNode;
  children?: ReactNode;
  progressResetKey?: string | number;
};

export const ScanStateLayout = ({
  heading,
  headingIcon,
  onAnimationComplete,
  imageSrc,
  children,
  progressResetKey,
}: ScanStateLayoutProps) => {
  return (
    <Flex direction={'column'} w={'100%'} alignItems={'flex-start'}>
      <HStack spacing={2}>
        {headingIcon}
        <Text fontWeight="bold" fontSize={20}>
          {heading}
        </Text>
      </HStack>
      {imageSrc ? (
        <Center w={'100%'}>
          <Image src={imageSrc} h={297} w={297} />
        </Center>
      ) : null}
      {children}
      <TimedProgress show={true} duration={2} onAnimationComplete={onAnimationComplete} resetKey={progressResetKey} />
    </Flex>
  );
};
